<ng-container *transloco="let t">
<div class="w-100">
  <h5 class="mt-2 mb-4 d-flex justify-content-center">
    <span style="max-width: 500px" class="text-gray-700 fs-4 fw-bold">
      {{ t('portal.prequal.reviewMessage') }}
    </span>
  </h5>

  <div class="my-2 d-flex justify-content-center">
    <table class="table" style="max-width: 500px">
      <tbody>
        <tr>
          <td><strong>{{ t('portal.prequal.stepPropertyAddress') }}</strong></td>
          <td>
            {{ request.address }} @if (request.city || request.state && request.zip) {
              <span>,</span>
            } {{ request.city }} {{ request.state }}
            {{ request.zip }}
          </td>
          <td>
            <a href="javascript:void(0)" class="nav-link" (click)="goToStep(2)">
              {{ t('portal.prequal.edit') }}
            </a>
          </td>
        </tr>
        <tr>
          <td><strong>{{ t('portal.prequal.stepPurchasePrice') }}</strong></td>
          <td>
            {{ request.purchasePrice | currency }}
          </td>
          <td>
            <a href="javascript:void(0)" class="nav-link" (click)="goToStep(3)">
              {{ t('portal.prequal.edit') }}
            </a>
          </td>
        </tr>
        <tr>
          <td><strong>{{ t('portal.prequal.stepDownPayment') }}</strong></td>
          <td>
            {{ request.downPayment | currency }}
          </td>
          <td>
            <a href="javascript:void(0)" class="nav-link" (click)="goToStep(4)">
              {{ t('portal.prequal.edit') }}
            </a>
          </td>
        </tr>
        @if (showAdditionalOptionsStep) {
          <tr>
            <td><strong>{{ t('portal.prequal.stepAdditionalOptions') }}</strong></td>
            <td> {{ request.includeAusFindings || request.includeProofOfFunds  ? t('portal.prequal.includes') : ''}} {{ request.includeAusFindings ? t('portal.prequal.ausFindings') : ''}}
              {{ request.includeProofOfFunds ? (request.includeAusFindings ? ', ' : '') + t('portal.prequal.proofOfFunds') : '' }}
            </td>
            <td>
              <a href="javascript:void(0)" class="nav-link" (click)="goToStep(5)">
                {{ t('portal.prequal.edit') }}
              </a>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  @if (haveEmptySections) {
    <div class="my-2 d-flex justify-content-center">
      <span style="max-width: 500px" class="text-danger">
        {{ t('portal.prequal.fillEmptySections') }}
      </span>
    </div>
  }

  <div class="d-flex justify-content-between my-2">
    <a href="javascript:void(0)" class="btn btn-light" (click)="closeClicked()">
      {{ t('common.close') }}
    </a>
    <a href="javascript:void(0)" class="btn bp-primary-bg-color" (click)="nextClicked()">
      {{ t('portal.prequal.generateButton') }}
    </a>
  </div>
</div>
</ng-container>

<style>
  td {
    text-align: start;
    vertical-align: middle;
  }
</style>
